/* GGC Release 4: product page gallery navigation. Scoped to .ggc-pdp. */
(function () {
  var ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>';
  function visibleItems(list) {
    return Array.prototype.filter.call(list.querySelectorAll('.thumbnail-list__item'), function (li) {
      return li.offsetParent !== null;
    });
  }
  function keepInView(list, item) {
    if (!item) return;
    if (list.scrollHeight > list.clientHeight + 1) {
      var top = item.offsetTop - list.offsetTop;
      if (top < list.scrollTop || top + item.offsetHeight > list.scrollTop + list.clientHeight) {
        list.scrollTo({ top: Math.max(0, top - (list.clientHeight - item.offsetHeight) / 2) });
      }
    }
  }
  function init(root) {
    var gallery = root.querySelector('media-gallery');
    if (!gallery || gallery.hasAttribute('data-ggc-nav')) return;
    var list = gallery.querySelector('.thumbnail-list');
    var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    if (!list || !viewer) return;
    gallery.setAttribute('data-ggc-nav', '');
    var nav = document.createElement('div');
    nav.className = 'ggc-gallery-nav';
    [['prev', 'Previous image', -1], ['next', 'Next image', 1]].forEach(function (cfg) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ggc-gallery-nav__btn ggc-gallery-nav__btn--' + cfg[0];
      b.setAttribute('aria-label', cfg[1]);
      b.innerHTML = ARROW;
      b.addEventListener('click', function () {
        var items = visibleItems(list);
        if (items.length < 2) return;
        var i = -1;
        items.forEach(function (li, idx) { if (li.querySelector('[aria-current="true"]')) i = idx; });
        if (i < 0) i = 0;
        var target = items[(i + cfg[2] + items.length) % items.length];
        var btn = target.querySelector('button');
        if (btn) btn.click();
        keepInView(list, target);
      });
      nav.appendChild(b);
    });
    viewer.appendChild(nav);
    var update = function () { nav.hidden = visibleItems(list).length < 2; };
    update();
    window.addEventListener('resize', update);
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.thumbnail-list__item');
      if (li) keepInView(list, li);
    });
  }
  function run() { document.querySelectorAll('.ggc-pdp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
